"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* Putting a picked template into the composer draft. Shared by the web and
 * mobile composers. */

var _templateResolver = require('./templateResolver');

/* What a template is filled with: the chat's values, and the built-in
 * defaults for values that are truly missing (templateDefaults). */












/* Fills the chat's known values into the template and writes the result over
 * the draft's selection. */
 const insertTemplate = (
  draft,
  selection,
  body,
  { values, defaults },
) => {
  const resolved = _templateResolver.resolveTemplate.call(void 0, body, values, defaults)
  const start = Math.max(0, Math.min(selection.start, selection.end, draft.length))
  const end = Math.min(draft.length, Math.max(selection.start, selection.end))
  const text = draft.slice(0, start) + resolved.text + draft.slice(end)
  const chip = resolved.unresolved[0]
  return {
    text,
    selection: chip
      ? { start: start + chip.start, end: start + chip.end }
      : { start: start + resolved.text.length, end: start + resolved.text.length },
  }
}; exports.insertTemplate = insertTemplate
